export default async function init() {
  if (window.snowhistPage !== "new") return

  const { default: SnowHistory } = await import(
    /* webpackChunkName: "show-history-page" */ "./snow-history"
  )

  SnowHistory()
}
